<template>
    <client-only>
        <schedule-x-calendar v-bind="$attrs">
            <template v-for="(slot, name) in $slots" v-slot:[name]="slotProps">
                <slot :name="name" v-bind="slotProps" />
            </template>
        </schedule-x-calendar>
    </client-only>
</template>

<script setup lang="ts">
    const ScheduleXCalendar = defineAsyncComponent(() =>
        import('@schedule-x/vue').then(module => module.ScheduleXCalendar)
    )

    onMounted(async () => {
        await import('@schedule-x/theme-default/dist/index.css')
    })
</script>
